import WebSocketsRepository from './WebSockets.repository';

export * from './interfaces';

export { WebSocketsRepository };

export const webSocketsRepository = new WebSocketsRepository();
